import { useEffect, useRef, useState } from 'react';
import { Card, CardContent } from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {COLORS, EXPORTING} from '../../../utils/constants';
import {roundTo} from '../../../utils/round';

interface ITassoProps {
  data: {
    average: number;
    uoa: number;
  };
  title?: string
}

const Tasso = ({data, title = undefined}: ITassoProps) => {
  const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
  const [options, setOptions] = useState<Highcharts.Options>();

  const calculateSubmissions = () => {
    const dashboardOptions: any = {
      chart: {
        height: 400,
        type: 'column',
        style: {
          fontFamily: 'Rubik, sans-serif'
        },
        backgroundColor: '#fafafa'
      },
      title: {
        text: title || '',
        align: 'left'
      },
      xAxis: {
        categories: ['Il mio progetto', 'Media dei progetti']
      },
      yAxis: {
        min: 0,
        max: 100,
        labels: {
          format: '{value}%'
        },
        title: {
          text: ''
        }
      },
      tooltip: {
        valueSuffix: '%'
      },
      plotOptions: {
        column: {
          cursor: 'pointer',
          stacking: 'normal',
        }
      },
      series: [
        {
          showInLegend: false,
          color: COLORS.blue,
          name: '',
          data: [roundTo(data.uoa * 100, 2), roundTo(data.average * 100, 2)]
        },
      ],
      exporting: EXPORTING
    };

    setOptions(dashboardOptions);
  };

  useEffect(() => {
    calculateSubmissions();
  }, []);

  return (
    <Card>
      <CardContent>
        {
          options && (
            <HighchartsReact
              highcharts={Highcharts}
              options={options}
              ref={chartComponentRef}
            />
          )
        }
      </CardContent>
    </Card>
  );
};

export default Tasso;
